import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { HowLHRWorks } from '../../components/lp/HowLHRWorks';

Builder.registerComponent(HowLHRWorks, {
    name: BUILDER_DIVIDER_NAMES.HowLHRWorks,
});
